import {Api} from '../../../Api.js'

const RESOURCE = 'inventory'

export default {
    resource: RESOURCE,
    prefix: 'shop/',
    query(query) {
        return Api().get(this.prefix + this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.prefix + this.resource + '/' + id)
    },
    clearCart() {
        return Api().get(this.prefix + this.resource + '/clear-cart')
    },
    create(data) {
        return Api().post(this.prefix + this.resource, data)
    },
    update(id, data) {
        return Api().put(this.prefix + this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.prefix + this.resource + '/' + id)
    },
    restore(id) {
        return Api().post(this.prefix + this.resource + '/restore/' + id)
    }
}


// WEBPACK FOOTER //
// ./src/modules/shop/inventory/InventoryService.js